<template>
  <tr
    style="cursor: pointer;"
    :class="{ 'blue lighten-5': updated, 'green lighten-5': created, 'grey lighten-4': closed}"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="!closed ? toggleEditLineDialog() : null"
  >
    <td @click.stop>
      <v-checkbox v-model="selected" :color="$store.state.global.pages.tipping.color" hide-details></v-checkbox>
    </td>

    <td v-for="(header,i) in headers" :key="i" :class="`text-xs-${header.align}`">
      <span
        v-if="header.type == 'date'"
      >{{ makeShortDate(getObjectPath(header.value, tippingDocket)) || '-' }}</span>
      <span
        v-if="header.type == 'num'"
      >{{ !!getObjectPathRootExists(header.value, tippingDocket) ? displayDecimal(getObjectPath(header.value, tippingDocket),header.decimals) : '-' || '-' }}</span>
      <span
        v-if="header.type == 'curr' "
      >{{ !!getObjectPath(header.value, tippingDocket) ? `$ ${displayDecimal(getObjectPath(header.value, tippingDocket),header.decimals)}` : '-' || '' }}</span>
      <span
        v-if="header.type == 'text'"
      >{{ !!getObjectPathRootExists(header.value, tippingDocket) ? getObjectPath(header.value, tippingDocket) : '-' || '-' }}</span>

      <span v-if="header.type == 'dayBool'">
        <v-icon v-if="getObjectPath(header.value, tippingDocket)" color="amber darken-1">wb_sunny</v-icon>
        <v-icon v-else color="blue-grey darken-3">nights_stay</v-icon>
      </span>

      <!--ACTIONS COLUMN -->
      <div
        v-if="header.type == 'action' && userAuthClass"
        class="justify-center layout px-0"
        @click.stop
      >
        <!-- <v-btn 
                icon 
                flat
                :color="closed ? $store.state.global.pages.allocation.color : 'grey'" 
                @click="commitDialog = !commitDialog"
                >
                    <v-icon>save</v-icon>
        </v-btn>-->
        <!-- TRIP OPTIONS MENU -->
        <v-menu bottom left>
          <v-btn icon flat color="grey" slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <basic-list-tile
              title="Edit"
              v-if="!closed"
              icon="edit"
              :onClick="toggleEditLineDialog"
            ></basic-list-tile>
            <basic-list-tile
              title="Edit Header"
              v-if="!closed"
              :icon="$store.state.global.pages.docket.icon"
              :onClick="toggleEditHeaderDialog"
            ></basic-list-tile>
            <basic-list-tile
              title="Delete"
              v-if="!closed"
              icon="delete"
              color="red lighten-3"
              :onClick="toggleDeleteDialog"
            ></basic-list-tile>
            <basic-list-tile
              title="Add Trip ID"
              v-if="!closed"
              :icon="$store.state.global.pages.docket.icon"
              :color="$store.state.global.pages.docket.color"
              :onClick="toggleAddTripDialog"
            ></basic-list-tile>
          </v-list>
        </v-menu>
      </div>
      <!--END ACTIONS COLUMN -->
    </td>
    <!-- END CELLS -->

    <!--  DIALOGS  -->
    <!-- Edit dialog -->
    <v-dialog lazy v-model="editLineDialog" max-width="700px" @keydown.esc="editLineDialog = false">
      <tipping-line-edit
        @close="editLineDialog = false"
        :tippingDocket="tippingDocket"
        @openEditHeader="toggleEditLineDialog(); toggleEditHeaderDialog();"
      ></tipping-line-edit>
    </v-dialog>
    <v-dialog
      lazy
      v-model="editHeaderDialog"
      max-width="700px"
      @keydown.esc="editHeaderDialog = false"
    >
      <tipping-header-edit
        @close="editHeaderDialog = false"
        :tippingDocket="tippingDocket.tippingDocketHeader"
      ></tipping-header-edit>
    </v-dialog>
    <!-- Delete dialog -->
    <v-dialog lazy v-model="deleteDialog" max-width="400px" @keydown.esc="deleteDialog = false">
      <delete-tipping-docket @close="deleteDialog = false" :tippingDocket="tippingDocket"></delete-tipping-docket>
    </v-dialog>
    <v-dialog lazy v-model="addTripDialog" max-width="400px" @keydown.esc="addTripDialog = false">
      <add-trip @close="addTripDialog = false" :tippingDocket="tippingDocket"></add-trip>
    </v-dialog>
  </tr>
</template>

<script>
import TippingLineEdit from "./tippingLineEdit";
import TippingHeaderEdit from "./tippingHeaderEdit";
import DeleteTippingDocket from "./tippingDocketDelete";
import AddTrip from "./addTrip";
// import CommitBatch from './tippingDocketCommit'
import FormatDates from "@/services/mixins/formatDates";
import Store from "@/store/computed/storeHelpers";
import TippingService from "@/services/requests/tippingService";

import CreatedUpdatedRows from "@/services/mixins/createdUpdatedRows";
import RowDisplayMethods from "@/services/mixins/rowDisplayMethods";
export default {
  mixins: [FormatDates, CreatedUpdatedRows, RowDisplayMethods],
  data() {
    return {
      prefix: "tippingDocket",
      addTripDialog: false,
      commitDialog: false,
      deleteDialog: false,
      editLineDialog: false,
      editHeaderDialog: false,
      actionConfirmationDialog: false,
      actionsMenu: false
    };
  },
  methods: {
    toggleEditLineDialog() {
      this.editLineDialog = !this.editLineDialog;
    },
    toggleEditHeaderDialog() {
      this.editHeaderDialog = !this.editHeaderDialog;
    },
    toggleAddTripDialog() {
      this.addTripDialog = !this.addTripDialog;
      //if (this.$store.state.user.userAuthClass.allocationStagingWrite) this.editDialog = !this.editDialog
    },
    toggleDeleteDialog() {
      this.deleteDialog = !this.deleteDialog;
    }
  },
  computed: {
    closed() {
      var array = ["COMPLETED", "NON-CLAIMABLE DOCKET", "CREDIT RECEIVED"];
      //return !!this.tippingDocket.trips.length
      return array.includes(this.tippingDocket.status);
    },
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", { value: val, object: this.tippingDocket });
      }
    }
  },
  props: {
    tippingDocket: Object,
    headers: Array,
    value: Boolean
  },
  components: {
    // EditBatch,
    DeleteTippingDocket,
    AddTrip,
    TippingLineEdit,
    TippingHeaderEdit
    // CommitBatch
  }
};
</script>

<style scoped>
</style>
